import React from 'react';
import { Phone, Mail, MapPin } from 'lucide-react';
import { useLanguage } from '../LanguageContext';

const Footer = () => {
  const { t } = useLanguage();
  return (
    <footer className="footer" id="contact">
      <div className="footer-top">
        <div className="footer-contact-grid">
          <div className="footer-contact-item">
            <Phone size={20} color="#c4a77d" style={{ marginBottom: '0.5rem' }} />
            <p>{t.footer.phoneLabel}:+381 65 801 96 73</p>
          </div>
          <div className="footer-contact-item">
            <Mail size={20} color="#c4a77d" style={{ marginBottom: '0.5rem' }} />
            <p>{t.footer.emailLabel}: office@unideatravel.com</p>
          </div>
          <div className="footer-contact-item">
            <MapPin size={20} color="#c4a77d" style={{ marginBottom: '0.5rem' }} />
            <p>{t.footer.addressLabel}</p>
          </div>
        </div>
      </div>

      <div className="footer-map-wrapper">
        <iframe
          title="Unidea Travel location"
          src="https://maps.google.com/maps?q=Dr%C5%BEi%C4%87eva%209%2C%20Belgrade&t=&z=15&ie=UTF8&iwloc=&output=embed"
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>

      <p>{t.footer.copyright}</p>
    </footer>
  );
};

export default Footer;